module.exports = __webpack_public_path__ + "files/2675d44ff47a6290d4e16ffaaffd692b.png";